import React from 'react'
import Loading from 'components/Loading/Loading'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  SSOToolButton,
  SSOToolColumnWrapper,
  SSOToolLayoutSection,
  SSOToolLayoutWrapper,
} from './styles'

import {
  FormikInputField,
  FormikSelectField,
  FormikDateField,
} from '../../../components/index'

export default function SSOToolLayout(props) {
  const { isSubmitting } = props || {}
  const providerList = ['Classlink', 'Clever', 'CleverRostering', 'Google']

  return (
    <SSOToolLayoutWrapper>
      <Loading isLoading={isSubmitting} message="One Moment Please...." />
      <SSOToolLayoutSection>
        <SSOToolColumnWrapper>
          <legend>Create Single Sign-on Integration</legend>
          <FormikSelectField
            data={providerList}
            id="provider"
            inputName="provider"
            dataTestId="sso-tool-select-provider"
            label="Provider:"
            name="provider"
            {...props}
          />
          <FormikInputField
            disabled={false}
            id="displayName"
            inputName="displayName"
            type="text"
            label="District's Display Name:"
            name="displayName"
            dataTestId="sso-tool-input-display-name"
            {...props}
          />
          <FormikInputField
            id="domains"
            inputName="domains"
            label='Domains (separated by "," if many):'
            dataTestId="sso-tool-input-domains"
            name="domains"
            type="text"
            value=""
            {...props}
          />
          <FormikDateField
            label="Active Date:"
            inputName="activeDate"
            name="activeDate"
            dataTestId="sso-tool-input-activeDate"
            placeholder="yyyy-mm-dd"
            {...props}
          />
          <FormikDateField
            label="End Date:"
            inputName="endDate"
            dataTestId="sso-tool-input-endDate"
            name="endDate"
            placeholder="yyyy-mm-dd"
            {...props}
          />
        </SSOToolColumnWrapper>
      </SSOToolLayoutSection>

      <div>
        <SSOToolButton color={'#002855'} disabled={false} type="submit">
          Create SSO
        </SSOToolButton>
      </div>
    </SSOToolLayoutWrapper>
  )
}
SSOToolLayout.propTypes = {
  enableSubmit: PropTypes.func.isRequired,
  enableValidation: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  values: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    domains: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
  }),
}
